import React from "react";
import { inject, observer } from "mobx-react";
import HomePageStore from "../HomePageStore";

interface promoRibbonProps {}

interface InjectedProps extends promoRibbonProps {
  homePageStore: HomePageStore;
}

const promoRibbon: React.SFC<promoRibbonProps> = (props) => {
  const { homePageStore } = props as InjectedProps;
  const { promoRibbon } = homePageStore.homePageContent.response;
  return !!promoRibbon ? (
    <div className="promoBar promoBar--onNow">
      <div className="promoBar__content">
        <div className="container container--large">
          <a
            href={promoRibbon.callToAction.url}
            className="promoBar__link"
            target={promoRibbon.callToAction.target}
          >
            <div className="promoBar__content">
              <h3 className="promoBar__title">{promoRibbon.title}</h3>
              <div className="promoBar__terms">{promoRibbon.subTitle}</div>
            </div>
            <div className="promoBar__btn btn btn--secondary">
              {promoRibbon.callToAction.name}
            </div>
          </a>
        </div>
      </div>
      <button className="promoBar__close">Close</button>
    </div>
  ) : (
    <></>
  );
};

export default inject("homePageStore")(observer(promoRibbon));
